import { useQuery } from '@tanstack/react-query';
import type { GameProfileResponse } from '@lunit/shared-types';
import { gameApi } from '@core/game/api';

export const useGameProfile = (userId?: string) => {
  return useQuery({
    queryKey: ['gameProfile', userId],
    queryFn: () => {
      if (!userId) {
        throw new Error('User id required');
      }
      return gameApi.getProfile(userId) as Promise<GameProfileResponse>;
    },
    enabled: Boolean(userId),
    refetchInterval: 5000
  });
};

